import React from 'react'
import Fade from  "react-reveal/Fade";
import DropdownMenu from "../../components/DropdownMenu"
const Banner = () => {  
  return (
    <section className="home-five-banner pt-5">
    <div className="container">
      <div className="row">
      <div className="col-xl-12 col-lg-12 text-right">
            </div>
        <div className="col-xl-6 col-lg-8">
          <div className="banner-content">
            <Fade left  delay={.2000}>
            <h6 className="sub-title wow fadeInUp">best of Score</h6>
            </Fade>
            <Fade left  delay={.4000}>
            <h2 className="title-one">Leaders</h2>
            </Fade>
            <Fade left  delay={.6000}>
            <h3 className="title-two" >Board <span>news</span></h3>
            </Fade>
            <Fade left  delay={.8000}>
            <div className="banner-meta" />
            
         </Fade>
            </div>
          </div>
        </div>
      </div>
    

   </section>
  )
}

export default Banner